__webpack_require__.p = "/stefanbrunotteportfolio/";